export default __webpack_public_path__ + "static/media/thumbnail0.bdabe792.jpg";